<template>
    <div id="main">
        <div class="page page-container">
            <alert-container :messages="msgs" />
            <h1 class="title">
                {{ $t('feriado') }}:
                {{ !feriados.idferiado ? $t('novo-feriado') : feriados.descricao }}
            </h1>
            <nav class="breadcrumb" aria-label="breadcrumbs">
                <ul>
                    <li>
                        <a class="a-inativo">{{ $t($route.meta.contexto) }}</a>
                    </li>
                    <li>
                        <a class="a-inativo">{{ $t('cadastros') }}</a>
                    </li>
                    <li>
                        <a @click="$router.push({ name: `${abrev}-feriados` })">{{
                            $t('feriados')
                        }}</a>
                    </li>
                    <li>
                        <a aria-current="page">{{
                            !feriados.idferiado ? $t('novo-feriado') : feriados.descricao
                        }}</a>
                    </li>
                </ul>
            </nav>
            <div class="vertical-flow">
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-6">
                            <v-input
                                v-model="feriados.descricao"
                                :id="'descricao'"
                                :placeholder="'descricao-do-feriado-placeholder'"
                                :maxlength="100"
                                :title="'descricao-do-feriado'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!feriados.descricao"
                                ref="descricaoInput"
                                :required="true"
                            />
                        </div>
                        <div class="column is-6">
                            <verified-date-picker
                                ref="dateInput"
                                id="saida"
                                v-model="dataFeriado"
                                title="data-do-feriado"
                                @input="changeDate"
                                :inForm="true"
                                :subtractDateDays="1"
                                :addDateYears="1"
                                :required="true"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-6 checkbox-row">
                            <b-radio
                                v-model="local"
                                name="locais"
                                id="nacional"
                                value="n"
                                native-value="n"
                            >
                                {{ $t('nacional') }}
                            </b-radio>
                            <b-radio
                                v-model="local"
                                name="locais"
                                id="estadual"
                                value="e"
                                native-value="e"
                            >
                                {{ $t('estadual') }}
                            </b-radio>
                            <b-radio
                                v-model="local"
                                name="locais"
                                id="local"
                                value="l"
                                native-value="l"
                            >
                                {{ $t('municipal') }}
                            </b-radio>
                        </div>
                        <div class="column is-6">
                            <div class="local-inputs">
                                <div class="estado-input" v-show="local == 'e'">
                                    <vs-select
                                        ref="estadoInput"
                                        :title="'estado'"
                                        :options="estados"
                                        v-model="estado"
                                        :search="loadEstado"
                                        :onChange="updateEstado"
                                        :focusin="loadEstado"
                                        :keydown="tabSelectEstado"
                                        :placeholder="'estado-do-promotor-placeholder'"
                                        :invalid="!feriados.estado"
                                    />
                                </div>
                                <div class="cidade-input" v-show="local == 'l'">
                                    <vs-select
                                        ref="cidadeInput"
                                        :title="'cidade'"
                                        :options="cidades"
                                        v-model="cidade"
                                        :search="loadCidade"
                                        :onChange="updateCidade"
                                        :focusin="loadCidade"
                                        :keydown="tabSelectCidade"
                                        :placeholder="'cidade-do-promotor-placeholder'"
                                        :invalid="!feriados.cidade"
                                    />
                                </div>
                                <div class="empty-box" v-if="local == 'n'">
                                    <span></span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-6">
                            <div>
                                <b-checkbox type="is-primary" v-model="repeteYear">
                                    {{ $t('repeteAnualmente') }}
                                </b-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-buttons">
                <button class="delete-btn" type="button" @click="redirectToPage()">
                    {{ $t('voltar') }}
                </button>
                <button
                    v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                    class="save-btn"
                    type="button"
                    @click="salvar()"
                    :disabled="isSaving"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import FeriadosService from '@/services/FeriadosService';
import EstadoService from '@/services/EstadoService';
import CidadeService from '@/services/CidadeService';
import FeriadoValidation from '@/services/validations/FeriadoValidation';
import Message from '@/models/Message';

export default {
    data() {
        return {
            service: new FeriadosService(this.$http, this.$router),
            cidadeservice: new CidadeService(this.$http, this.$router),
            estadoservice: new EstadoService(this.$http, this.$router),
            isSaving: false,
            feriados: {
                data: '',
                cidade: null,
                estado: null,
                repete: null,
            },
            repeteYear: false,
            title: '',
            msgs: [],
            touched: false,
            local: 'n',
            estado: null,
            estados: [],
            cidade: null,
            cidades: [],
            dataFeriado: null,
            canSelectCidade: false,
            canSelectEstado: false,
            isUpdate: false,
            abrev: '',
        };
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;

        this.abrev = this.$route.meta.contexto;
        if (this.$route.meta.contexto == 'vendas') {
            this.permissao = this.hasPermissionAccess('vendas', 'empresa', 'vendas-feriados');
        } else if (this.$route.meta.contexto == 'promotor') {
            this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'promotor-feriados');
        } else if (this.$route.meta.contexto == 'despesas') {
            this.permissao = this.hasPermissionAccess('despesas', 'empresa', 'des-feriado');
            this.abrev = this.$route.meta.contexto.slice(0, 3);
        } else {
            this.permissao = this.hasPermissionAccess('agro', 'empresa', 'agro-feriado');
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'feriado' },
            });
        } else {
            if (!this.isUpdate && !this.permissao.create) {
                this.$router.push({
                    name: 'acesso-nao-permitido',
                    params: { tela: 'feriado' },
                });
            }

            this.validation = new FeriadoValidation(this.msgs, this.$moment);
            if (this.$route.params.id) {
                this.carregarDados(this.$route.params.id);
            }
        }
    },
    mounted() {
        this.$refs.descricaoInput.$refs.typed.focus();
    },
    methods: {
        tabSelectCidade(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectCidade = true;
            if (e.code == 'Tab' && this.canSelectCidade) {
                this.$refs.cidadeInput.typeAheadSelect();
                this.$refs.cidadeInput.focus();
            }
        },
        tabSelectEstado(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectEstado = true;
            if (e.code == 'Tab' && this.canSelectEstado) {
                this.$refs.estadoInput.typeAheadSelect();
                this.$refs.estadoInput.focus();
            }
        },
        carregarDados(id) {
            this.$store.commit('addLoader');

            this.service
                .find(id)
                .then((body) => {
                    if (body.content) {
                        let f = body.content;

                        this.feriados = f;
                        this.repeteYear = f.repete == 'YEAR' ? true : false;
                        this.dataFeriado = this.$moment(f.data).toDate();
                        this.title = this.feriados.descricao;

                        if (this.feriados.cidade) {
                            this.loadCidade();
                            this.local = 'l';
                            this.cidade = {
                                id: this.feriados.cidade.id,
                                label: this.feriados.cidade.descricao,
                                obj: this.feriados.cidade,
                            };
                        } else if (this.feriados.estado) {
                            this.loadEstado();
                            this.local = 'e';
                            this.estado = {
                                id: this.feriados.estado.id,
                                label: this.feriados.estado.descricao,
                                obj: this.feriados.estado,
                            };
                        }
                    } else {
                        this.$router.push({ name: 'new-feriado' });
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar feriado.', e);
                })
                .finally((_) => {
                    this.$store.commit('removeLoader');
                });
        },
        salvar(redirect = this.redirectToPage) {
            if (this.validation.validate(this.feriados, this.$refs)) {
                if (this.local == 'n') {
                    this.feriados.cidade = null;
                    this.feriados.estado = null;
                }

                this.feriados.repete = this.repeteYear ? 'YEAR' : null;

                this.feriados = this.mapTosave(this.feriados);
                this.isSaving = true;

                this.service
                    .save(this.feriados)
                    .then((body) => {
                        if (body.status != 200) {
                            this.msgs.push(new Message('error', body.message, true));
                            this.isSaving = false;
                            //return;
                        } else {
                            let msg = 'msg-feriado-salvo';

                            if (this.feriados.id) {
                                msg = 'msg-feriado-editado';
                            }

                            this.feriados = body.content;
                            this.msgs.push(new Message('success', msg, true));
                            this.isSaving = false;
                            redirect();
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                        this.isSaving = false;
                    });
            }
        },
        mapItems(body) {
            let list = body.content.map((i) => {
                return {
                    id: i.id,
                    label: i.descricao,
                    obj: i,
                };
            });
            return list;
        },
        loadCidade(value) {
            this.cidadeservice
                .findAll(0, 100, value ? value : '')
                .then(this.mapItems)
                .then((allcidades) => {
                    let cid = allcidades.filter(
                        (c) => this.cidade && c.id.idcidade == this.cidade.id.idcidade
                    )[0];
                    if (!cid && this.cidade) {
                        allcidades.push(this.cidade);
                    }
                    this.cidades = allcidades;
                    this.cidades.sort();
                }, 350);
        },
        loadEstado(value) {
            this.estadoservice
                .findAll(0, 100, value ? value : '')
                .then(this.mapItems)
                .then((allestados) => {
                    let es = allestados.filter(
                        (e) => this.estado && e.id.idestado == this.estado.id.idestado
                    )[0];
                    if (this.estado && !es) {
                        allestados.push(this.estado);
                    }
                    this.estados = allestados;
                    this.estados.sort();
                }, 350);
        },
        updateCidade(cidade) {
            if (cidade) {
                this.feriados.cidade = cidade.obj;
                this.cidade = cidade;
                if (this.estado) {
                    this.updateEstado(this.cidade.id.estado, false);
                }
            } else {
                this.feriados.cidade = null;
                this.cidade = null;
            }
            this.canSelectCidade = false;
        },
        updateEstado(estado, updateCidade = true) {
            if (estado) {
                this.feriados.estado = estado.obj;
                this.estado = estado;
                if (this.cidade && updateCidade) {
                    this.updateCidade();
                }
            } else {
                this.feriados.estado = null;
                this.estado = null;
            }
            this.canSelectEstado = false;
        },
        changeDate(date) {
            this.dataFeriado = date;

            this.feriados.data = this.$moment(this.dataFeriado).format('YYYY-MM-DD');
        },
        redirectToPage() {
            let tempTela = null;
            console.log(this.$route.query.tela);

            if (this.$route.query.tela == `${this.abrev}-turnos-feriados`) {
                tempTela = `${this.abrev}-turno-edit`;
            } else {
                tempTela = `${this.abrev}-feriados-list`;
            }
            const route = {
                name: tempTela,
                params: { id: this.$route.query['id'] },
                query: {
                    abaSelecionada: this.$route.query.abaSelecionada,
                    dadoscadastrais: this.$route.query.dadoscadastrais,
                    politicacomercial: this.$route.query.politicacomercial,
                    analisecomercial: this.$route.query.analisecomercial,
                },
            };
            setTimeout(() => {
                this.$router.push(route);
            }, 1000);
        },
    },
    computed: {
        startvalidation: function (v) {
            return !this.feriados.data && this.touched;
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
}
.page {
    position: relative;
    margin-bottom: 40px;

    .novos-feriados {
        position: relative;
        width: 100%;
        margin-bottom: 20px;
        height: 100%;
        padding-top: 0;
        > h1 {
            padding-top: 20px;
            margin-bottom: 40px;
        }
    }
}

.novos-feriados .center {
    width: 100%;
    left: 0;
    transform: translateX(0);
    margin: 0;
    box-sizing: border-box;
    position: initial;
}

@media only screen and (min-width: 760px) {
    nav.breadcrumb {
        margin-right: 410px;
    }
}

.checkbox-row {
    margin-top: 20px;
    font-size: 10px;
}

.empty-box {
    height: 60px;
}

.local {
    margin-top: 5px;
    width: 49.5%;
    height: 40px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    > .radio-box {
        margin-right: 20px;
        margin-bottom: 0;

        input {
            position: absolute;
            left: 0;
        }
    }
}

.page .form {
    // display: block;
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-radius: 2px;
    text-align: left;

    .local {
        margin-top: 5px;
        width: 49.5%;
        height: 40px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        > .radio-box {
            margin-right: 20px;
            margin-bottom: 0;

            input {
                position: absolute;
                left: 0;
            }
        }
    }

    .local-inputs {
        width: 49.5%;
    }

    .anualmente {
        margin-top: 5px;
        width: 1000%;
        height: 40px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        > .check-box {
            margin-right: 20px;
            margin-bottom: 0;

            input {
                position: absolute;
                left: 0;
            }
        }
    }
}
</style>
